<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="우리말 해석을 보고 영어 문장을 완성합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <p class="sentence text-primary">{{content.translation}}</p>            
        </vs-row>
      </div> 
      <vs-divider></vs-divider>
      <div class="lg:p-8 md:p-6 sm:p-4 p-4 rounded-lg mb-base text-center">
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <vs-col class="w-full">
              <input
                class="tc-sentence-input"
                :placeholder="hint ? content.sentence : ''"
                v-model="userAnswer" 
                v-on:keyup.enter="onAnswer"
              />
            </vs-col>
        </vs-row>
      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>

</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      hint: false,
      contentIndex: 0,
      usedHintCount: 0,
      retryCount: 0,
      userAnswer: ''
    }
  },
  watch: {
    sourceContent () {
      this.contentList = []
      this.parseContent()
      this.onReload()
    }
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.hint = false
      this.contentIndex = 0
      this.usedHintCount = 0
      this.retryCount = 0
      this.studyResult = []
      this.startAlert()
    },
    onStart () {
      
    },
    onHint () {
      if (this.usedHintCount >= this.hintCount) {
        this.finishHintDlg()
      } else {
        this.usedHintCount++
        this.hint = true
      }
    },
    startAlert () {
      this.startStudyDlg('우리말 해석을 보고 영어 문장을 완성합니다.')
    },
    acceptAlert () {
      
    },
    onAnswer () {
      
      if (this.userAnswer.length === 0) return

      this.userAnswer.substring(0, 1).toUpperCase()

      const firstChar = this.userAnswer[0]
      const firstCharUpper = firstChar.toUpperCase()
      const leftChar = this.userAnswer.slice(1, this.userAnswer.length)
      const result = firstCharUpper + leftChar
      this.userAnswer = result

      if (this.content.sentence === this.userAnswer) {
        this.addResult(this.content.sentence, this.userAnswer) 
        this.correct()
      } else {
        this.inCorrect()
        this.retryCount++
        if (this.retryCount < this.retry) {
          return
        }
        this.addResult(this.content.sentence, this.userAnswer) 
      }
      if (this.contentIndex < this.contentsLen - 1) {
        
        setTimeout(function () {
          this.retryCount = 0
          this.contentIndex++
          this.userAnswer = ''
          this.hint = false
        }.bind(this), 1500)

      } else {
        this.onComplete()   
      }  
    },
    parseContent () {

      const contentJson = JSON.parse(this.sourceContent.contentBody)

      for (let i = 0; i < contentJson.sentence.length; i++) {
        const content = {
          sentence: contentJson.sentence[i],
          translation: contentJson.translation[i]
        } 
        this.contentList.push(content)
      }
      this.contentsLen = this.contentList.length
    }
  },
  
  created () {

    this.parseContent()
    this.startAlert()
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
.tc-sentence-input {
  height: 50px;
  font-size: 30px;
  text-align: center;
  width: 100%;
  border:1px solid #7367F0;
  color: #7367F0;
}
</style>
